<template>
  <div class="content">
    <div class="header">
      <el-select placeholder="账龄类型" size="mini" clearable v-model="where2.age">
        <el-option :value="1" label="当期"></el-option>
        <el-option :value="2" label="纯上一年"></el-option>
        <el-option :value="3" label="1年以上2年以内"></el-option>
        <el-option :value="4" label="2年以上"></el-option>
      </el-select>
      <el-input clearable placeholder="输入房产" v-model="where2.house_name" style="width: 200px" size="mini"></el-input>
      <el-date-picker
        style="width: 150px"
        v-model="where2.jh_time"
        size="mini"
        type="month"
        format="yyyy-MM"
        value-format="yyyy-MM" placeholder="催费月份">
      </el-date-picker>
      <el-button v-if="urge_type" type="primary" size="mini" @click="exportExcel">导出模板</el-button>
    </div>
    <div class="header-tip">
      申请房产数：{{pageData.total}}
    </div>
    <div class="body">
      <div>
        <div class="table-wrap">
          <el-table
            v-loading="loading"
            v-if="pageData" :data="pageData.list"
            border
            style="width: 100%">
            <el-table-column
              prop="房产信息"
              label="房产信息" width="320" fixed></el-table-column>
            <el-table-column
              prop="区域"
              label="区域"
              width="90">
            </el-table-column>
            <el-table-column
              prop="业主"
              label="业主姓名"
              width="100">
            </el-table-column>
            <el-table-column
              prop="业主电话"
              label="业主电话"
              width="150">
            </el-table-column>
            <el-table-column
              label="银行划扣"
              width="90">
              <template slot-scope="scope">
                <span style="color: #328628" v-if="scope.row.bankType">是</span>
                <span v-if="!scope.row.bankType"></span>
              </template>
            </el-table-column>
            <el-table-column
              prop="欠费起始月份"
              label="欠费起始月份"
              width="120">
            </el-table-column>
            <el-table-column
              prop="欠费月数"
              label="欠费月数"
              width="100">
            </el-table-column>
            <el-table-column
              prop="欠费金额"
              label="欠费金额"
              width="100">
              <template slot-scope="scope">
                <el-link type="primary" size="mini" @click="getHouseBill(scope.row)">{{ scope.row['欠费金额'] }}</el-link>
              </template>
            </el-table-column>
            <el-table-column
              prop="催缴类型"
              label="催缴类型"
              width="90">
            </el-table-column>
            <el-table-column
              prop="第三方合作单位"
              label="第三方合作单位"
              width="150">
            </el-table-column>
            <el-table-column
              prop="账龄类型"
              label="账龄类型"
              width="90">
            </el-table-column>
            <el-table-column
              prop="缴费类型"
              label="缴费类型"
              width="90">
            </el-table-column>
            <el-table-column
              prop="计划催缴月份"
              label="计划催缴月份"
              width="100">
            </el-table-column>
            <el-table-column
              prop="flow_status"
              label="审批状态"
              width="100">
            </el-table-column>
            <el-table-column
              prop="上次缴费时间"
              label="上次缴费时间"
              width="150">
            </el-table-column>
            <el-table-column
              prop="第一次催费时间"
              label="第一次催费时间"
              width="150">
            </el-table-column>
            <el-table-column
              prop="第二次催费时间"
              label="第二次催费时间"
              width="150">
            </el-table-column>
            <el-table-column
              prop="第三次催费时间"
              label="第三次催费时间"
              width="150">
            </el-table-column>
            <el-table-column
              prop="催费次数"
              label="催费次数"
              width="90">
            </el-table-column>
            <el-table-column
              prop="欠费类型"
              label="欠费类型"
              width="150">
            </el-table-column>
<!--            <el-table-column-->
<!--              prop="欠费原因"-->
<!--              label="欠费原因"-->
<!--              width="150">-->
<!--            </el-table-column>-->
            <el-table-column
              prop="业主诉求"
              label="业主诉求"
              width="150">
            </el-table-column>
            <el-table-column
              prop="解决措施"
              label="催费措施"
              width="150">
            </el-table-column>
            <el-table-column
              label="操作"
              fixed="right"
              width="150">
              <template slot-scope="scope">
                <el-link type="primary" @click="openFlow(scope.row)">审批流程</el-link>&nbsp;&nbsp;&nbsp;&nbsp;
<!--                <el-button type="text" size="mini" @click="openFlow(scope.row)">查看流程</el-button>-->
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination-wrap">
          <el-pagination background layout="prev, pager, next" :total="pageData.total*1"
                         :page-size="pageData.pageSize*1" :current-page="pageData.page*1"
                         @current-change="pageChange"></el-pagination>
        </div>
      </div>
    </div>
    <ViewFlow ref="viewFlowRef" />
    <LegalHouseMoneyList ref="legalHouseMoneyListRef" />
  </div>
</template>

<script>
import moment from "moment";
import {CommonHelp} from "../../common/CommonHelp";
import ViewFlow from "../../../Common/ViewFlow";
import ButlerHttp from "../../common/ButlerHttp";
import LegalHouseMoneyList from "../LegalHouseMoneyList";

export default {
  name: "ThirdPartyLegalPlan2",
  components: {LegalHouseMoneyList, ViewFlow},
  inject:['where','reginWhere'],
  props: {
    urge_type:{
      type:Number,
      default:0
    }
  },
  data(){
    return{
      where2:{
        age:"",
        type:"",
        jh_time:"",
        house_name:"",
      },
      loading:false,
      pageData:{
        list: [],
        total: 0,
        pageSize: 15,
        page: 1,
      },
    }
  },
  mounted() {
    const that=this;
    that.getList();
  },
  watch:{
    "reginWhere.type_id":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "reginWhere.project_region":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "reginWhere.project_name":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "reginWhere.area_id":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.age":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.type":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.start_time":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.house_name":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.jh_time":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
  },
  methods:{
    getList(){
      const that = this;
      that.loading = true;
      let where = {
        ...that.where2,
        urge_type:that.urge_type,
        project_ids:that.reginWhere.project_ids,
        project_id:that.reginWhere.project_name,
        area_id:that.reginWhere.area_id
      }

      ButlerHttp.post("ThirdPartyLegal/getFlowLegalHouseList", {
        ...where,
        flow_status: 1,
        page: that.pageData.page,
        pageSize: that.pageData.pageSize
      }, res => {
        if (res.code) {
          that.pageData = res.data;
        }
        that.loading = false;
      });
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    getHouseBill(item){
      const that=this;
      that.$refs.legalHouseMoneyListRef.show({
        project_id:item.PrecinctID,
        house_id:item.HouseID,
      })
    },
    openFlow(item){
      const that = this;
      if(!item.task_id){
        that.$message.error('没有审批流程')
        return;
      }
      that.$refs.viewFlowRef.show({task_id:item.task_id})
    },
    exportExcel() {
      const that = this;
      if(!that.reginWhere.project_name){
        that.$message.error("请选择项目")
        return false
      }
      const loading=that.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let where = {
        project_ids:that.reginWhere.project_ids,
        project_id:that.reginWhere.project_name
      }
      //"admin/"+that.urge_type+"/exportExcel"
      ButlerHttp.post(""+that.urge_type+"/exportExcel", {
        ...where
      }, res => {
        loading.close();
        if (res.code) {
          window.open(__HTTP__.defaults.baseURL + res.data);
        } else {
          that.$message.error(res.msg);
        }
      });
    },
  }
}

</script>

<style lang="scss" scoped>
@import "../../common";
.content{
  min-height: calc(100vh - 350px);

  .header-tip{
    margin: 5px 0;
    padding: 5px 10px;
    background-color: #f56c6c;
    color: #FFFFFF;
    border-radius: 4px;
    display: inline-block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/plan/ThirdPartyLegalPlan2.vue